const tripmap = document.querySelectorAll('.swt-Ultimate_TripMap');
window.fireOnVisible(tripmap, async (elem, entry, io) => {
    await import('./js/ultimate_tripmap.js').then((TripMap) => {
        TripMap = TripMap.default;

        const tripMapClass = '.swt-Ultimate_TripMapCanvas';
        const tripMapElements = elem.querySelectorAll(tripMapClass);

        tripMapElements.forEach((tripMapElem) => {
            window.fireOnVisible(tripMapElem, async (elem, entry) => {
                const mapElement = document.querySelector(tripMapClass + '[data-map-id="' + elem.dataset.mapId + '"]');
                let waypoints = null;
                if (mapElement) {
                    const tripMapOptions = {
                        pinIcon: mapElement.dataset.pintyp,
                        pinColor1: mapElement.dataset.pinColor1,
                        pinColor2: mapElement.dataset.pinColor2,
                        transfer: mapElement.dataset.transfer,
                        hasRoute: mapElement.dataset.route === '1',
                        vertical: window.TCMS.product
                    };

                    if (mapElement.dataset.waypoints) {
                        waypoints = JSON.parse(mapElement.dataset.waypoints);
                    }

                    const tripMap = new TripMap(mapElement, tripMapOptions, waypoints);
                    tripMap.init();
                }
            });
        });
    });
});
